module.exports = __webpack_public_path__ + "img/regular_cycle_4.3b807b5e.jpg";